import { render } from "./ApplyBatchConfigTemplate.vue?vue&type=template&id=1572c2cd"
import script from "./ApplyBatchConfigTemplate.vue?vue&type=script&lang=js"
export * from "./ApplyBatchConfigTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__